import React from "react";
import Button from "../../../ui/Button";
import { useAppDispatch, useAppSelector } from "../../../../redux/app/hooks";
import { exportUsersCsvAsync } from "../../../../redux/features/adminSlice";
import { ExportUsersCsvParams } from "../../../../apis/admin";

type ExportUsersCsvButtonProps = {
  params: Omit<ExportUsersCsvParams, "page" | "limit">;
  totalItems?: number;
};

const ExportUsersCsvButton: React.FC<ExportUsersCsvButtonProps> = ({
  params,
  totalItems = 0,
}) => {
  const dispatch = useAppDispatch();
  const isExporting = useAppSelector((state) => state.admin.isExporting);

  const handleExport = () => {
    dispatch(exportUsersCsvAsync(params));
  };

  return (
    <Button
      layout="toolbar"
      size="sm"
      variant="solid"
      label="Export CSV"
      isLoading={isExporting}
      disabled={isExporting || totalItems < 1}
      onClick={handleExport}
    />
  );
};

export default ExportUsersCsvButton;
